import React from 'react';
import cn from 'classnames';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import IconTrace from '@dealroadshow/uikit/core/components/Icon/IconTrace';
import Link from '@/Framework/Router/Next/Link/Link';
import Url from '@/finsight/infrastructure/url';
import SearchInput from '@/finsight/ui/components/trace/common/SearchInput';
import { useTraceChartContext } from '@/finsight/application/Trace/TraceChartContext';

import styles from '@/finsight/ui/components/trace/TraceTile/TraceTileHeader/traceTileHeader.scss';
import traceStyles from '@/finsight/ui/components/trace/trace.scss';

interface IProps {
  withChart: boolean,
}

const TileHeaderContent = ({ withChart }: IProps) => {
  const { chartData } = useTraceChartContext();

  const stylesWithChart = withChart && !!chartData.length;

  return (
    <div className={ cn(traceStyles.headerRow, { [traceStyles.headerRowNoData]: stylesWithChart }) }>
      <div className={ cn(traceStyles.titleContainer, { [traceStyles.withChart]: stylesWithChart }) }>
        <div className={ cn(traceStyles.titleTools, { [traceStyles.withChart]: stylesWithChart }) }>
          { (!chartData.length || !withChart) && <h3 data-test="traceChartTitle">TRACE</h3> }
          <Tooltip
            content="Go to TRACE"
            containerClassName={ cn(styles.questionIconTooltip, styles.traceIconContainer) }
          >
            <Link to={ Url.getTraceUrl() } dataTest="goToTraceLink">
              <IconTrace
                className={ styles.traceIcon }
              />
            </Link>
          </Tooltip>
        </div>
        <div className={ traceStyles.searchInputWrapper }>
          <SearchInput />
        </div>
      </div>
    </div>
  );
};

export default TileHeaderContent;
